import { motion } from "framer-motion";
import { CheckCircle2, Sparkles, RefreshCw, LineChart } from "lucide-react";

const fadeInUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-100px" },
};

const differentials = [
  {
    icon: Sparkles,
    title: "Estratégia Personalizada",
    description: "Cada negócio é único. Criamos estratégias sob medida para suas necessidades e objetivos.",
  },
  {
    icon: CheckCircle2,
    title: "Foco em Resultado",
    description: "Não trabalhamos com métricas de vaidade. Nosso objetivo é gerar clientes e aumentar seu faturamento.",
  },
  {
    icon: RefreshCw,
    title: "Otimização Contínua",
    description: "Monitoramento e ajustes constantes para garantir a melhor performance possível.",
  },
  {
    icon: LineChart,
    title: "Decisões Baseadas em Dados",
    description: "Todas as decisões são fundamentadas em análise de dados, não em achismos.",
  },
];

export const DifferentialsSection = () => {
  return (
    <section
      id="diferenciais"
      data-testid="differentials-section"
      className="relative py-24 lg:py-32 bg-[#050505] section-gradient-blue"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          {...fadeInUp}
          transition={{ duration: 0.6 }}
          className="text-center mb-16 lg:mb-20"
        >
          <span className="font-outfit uppercase tracking-[0.2em] text-xs font-semibold text-[#2563EB] mb-4 block">
            Por que escolher a Andiaras
          </span>
          <h2 className="font-outfit font-bold text-3xl sm:text-4xl lg:text-5xl text-white mb-6">
            Nossos Diferenciais
          </h2>
        </motion.div>

        {/* Differentials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {differentials.map((diff, index) => (
            <motion.div
              key={index}
              {...fadeInUp}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              data-testid={`differential-${index}`}
              className="glass-card bento-card rounded-2xl p-8 lg:p-10 group"
            >
              <div className="flex items-start gap-5">
                <div className="w-14 h-14 rounded-xl icon-container flex items-center justify-center flex-shrink-0 group-hover:bg-[#2563EB]/20 transition-colors duration-300">
                  <diff.icon className="w-7 h-7 text-[#2563EB]" />
                </div>
                <div>
                  <h3 className="font-outfit font-semibold text-xl text-white mb-3">
                    {diff.title}
                  </h3>
                  <p className="text-[#A1A1AA] leading-relaxed">
                    {diff.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
